import type {
  IconGlyph,
  IconStyle,
} from '@ipfabric/ui-components/Icon/IconGlyph';
import type { ButtonSize, IconPosition } from 'components/Button/Button';
import { ButtonIcon } from 'components/Button/ButtonIcon';
import type { ReactElement, ReactNode } from 'react';

export const renderButtonContent = (props: {
  children: ReactNode;
  // optional props are intentionally mandatory here
  // to not forget to pass them from button
  icon: IconGlyph | undefined;
  iconPosition: IconPosition | undefined;
  iconStyle: IconStyle | undefined;
  loading: boolean | undefined;
  size: ButtonSize | undefined;
}): ReactElement => {
  const buttonIcon = (
    <ButtonIcon
      icon={props.icon}
      loading={props.loading}
      size={props.size}
      style={props.iconStyle}
    />
  );
  return (
    <>
      {props.iconPosition !== 'right' && buttonIcon}
      <span className='button__text'>{props.children}</span>
      {props.iconPosition === 'right' && buttonIcon}
    </>
  );
};
